<template>
  <section class="o-container o-container--responsive mv-64">
    <div class=" u-align-center mv-64">
      <bl-button-av size="large" class="ph-48" @click="$emit('click')">
        {{ $options.StartTransaction }}
      </bl-button-av>
    </div>
  </section>
</template>
<script>
/* istanbul ignore file */
import BlButtonAv from '@bukalapak/bazaar-dweb-2/dist/components/BlButtonAv';
import { StartTransaction } from 'shared/modules/seo/Homepage';

export default {
  name: 'StartTransaction',

  StartTransaction,

  components: {
    BlButtonAv,
  },
};
</script>
